export default "__VITE_ASSET__C3o3c_GK__"